interface DetailRowProps {
  label: string
  value: string | number | null | undefined
  emptyText?: string
  className?: string
}

export function DetailRow({
  label,
  value,
  emptyText = '-',
  className = '',
}: DetailRowProps) {
  return (
    <div className={`flex flex-wrap ${className}`}>
      <span className="shrink-0 font-geist text-sm font-normal leading-5 text-[#737373]">
        {label}:
      </span>
      <span className="ml-1 break-words font-geist text-sm font-normal leading-5 text-[#262626]">
        {value || emptyText}
      </span>
    </div>
  )
}
